import request from '@/utils/$x';

// 获取七牛云token
export async function qiniuToken() {
  return request({
    url: '/qiniu',
    method: 'get',
  });
}

// 上传到七牛
export async function uploadToQiniu(file, qiniuTokenRes) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const url = 'https://up.qbox.me';
    const formData = new FormData();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          try {
            const res = JSON.parse(xhr.response);
            resolve(res);
          } catch (e) {
            reject(e);
          }
        } else {
          reject(new Error(xhr.statusText));
        }
      }
    };

    formData.append('token', qiniuTokenRes.uptoken);
    formData.append('file', file);
    xhr.open('POST', url, true);
    xhr.send(formData);
  }).then((res) => res);
}
